export default "__VITE_ASSET__C7rLDjFB__"